import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as actions from './actions';
import { toSingleArray } from 'utilities';
import { getAllRubros } from 'api/services/worksFields';
import {
  getCities,
  getDocumentsTypes,
  getEducationsLevels,
} from 'api/services/config';
function* watchGetWorksFields() {
  yield takeEvery(types.GET_WORKS_FIELDS, function* ({ payload }) {
    try {
      const { data } = yield call(getAllRubros, payload);
      const { duros, blandos } = data.workFields.subcategories;
      const singleArrayWorksFields = [
        ...toSingleArray(duros),
        ...toSingleArray(blandos),
      ].sort((a, b) => a?.name?.localeCompare(b?.name));
      yield put(actions.getWorksFieldsSuccess(singleArrayWorksFields));
    } catch (error) {
      yield put(actions.getWorksFieldsError());
    }
  });
}

function* watchGetCities() {
  yield takeEvery(types.GET_CITIES, function* ({ payload }) {
    try {
      const { data } = yield call(getCities, payload);
      yield put(
        actions.getCitiesSuccess(
          data.elements?.map((v) => ({
            id: v.id,
            label: v.city,
            state: v.state,
          })),
        ),
      );
    } catch (error) {
      yield put(actions.getCitiesError(error));
    }
  });
}

function* watchDocumentsType() {
  yield takeEvery(types.GET_DOCUMENTS_TYPES, function* ({ payload }) {
    try {
      const { data } = yield call(getDocumentsTypes, payload);
      yield put(
        actions.getDocumentsTypesSuccess(
          data.elements?.map((v) => ({ id: v.id, label: v.type })),
        ),
      );
    } catch (error) {
      yield put(actions.getDocumentsTypesError(error));
    }
  });
}

function* watchEducationsLevel() {
  yield takeEvery(types.GET_EDUCATIONS_LEVEL, function* ({ payload }) {
    try {
      const { data } = yield call(getEducationsLevels, payload);
      yield put(
        actions.getEducationsLevelsSuccess(
          data.elements?.map((v) => ({ id: v.id, label: v.name })),
        ),
      );
    } catch (error) {
      yield put(actions.getEducationsLevelsError(error));
    }
  });
}

function* SystemSagas() {
  yield all([
    fork(watchGetWorksFields),
    fork(watchGetCities),
    fork(watchDocumentsType),
    fork(watchEducationsLevel),
  ]);
}

export default SystemSagas;
